var Buffer = require('buffer').Buffer;

module.exports = isBuffer;

function isBuffer (o) {
  return Buffer.isBuffer(o)
    || /\[object (.+Array|Array.+)\]/.test(Object.prototype.toString.call(o));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/isbuffer/index.js
// module id = 379
// module chunks = 0